import React, { useState , useEffect } from "react";
import "./UserLogin.css";
import { LoginPageImage, snoopy } from "../../../assets";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";

import { useNavigate } from "react-router-dom";

import axios from "axios";

const UserLogin = () => {
  const [loginRequest, setLoginRequest] = useState({
    contactNo: "",
    password: "",
  });
  const [showPassword, setShowPassword] = useState(false);
  const [outletData, setOutletData] = useState([]);
  const [outletId, setOutletId] = useState(null);
  const [loginVisible,setLoginVisible] = useState("Yes");
  const API_BASE_URL = process.env.REACT_APP_SERVER_API;
  
  const saveToLocalStorage = (distanceData) => {
    localStorage.setItem("latitude", distanceData.latitude);
    localStorage.setItem("longitude", distanceData.longitude);
    localStorage.setItem("freeDistance", distanceData.freeDistance);
    localStorage.setItem("ratePerKm", distanceData.ratePerKm);
    localStorage.setItem("minDeliveryCharge", distanceData.minDeliveryCharge);
};

useEffect(() => {
  const deliveryBoyId = localStorage.getItem("deliveryBoyId");

  if (deliveryBoyId) {
    setLoginVisible("No"); 
    navigate("/QrDashbordNavbar", { state: { deliveryBoyId } }); 
  } else {
    setLoginVisible("Yes"); 
  }
}, []);

  const navigate = useNavigate();

  
  const userLogin = async (e) => {
    e.preventDefault(); // Prevent form default submission
  
    try {
      const response = await axios.post(`${API_BASE_URL}/DeliveryBoy/riderlogin`, loginRequest);
  
      if (response?.data?.deliveryBoyId) {
        localStorage.setItem("deliveryBoyId", response.data.deliveryBoyId);
        localStorage.setItem("outletId", response.data.outletId)
        localStorage.setItem("delboyName", response.data.delboyName)
        console.log("Login successful:", response.data);
  
        // Fetch outlet details if available
        
          getOutletData(response.data.outletId);
      
  
        setLoginVisible("No"); 
        navigate("/QrDashbordNavbar", { state: { deliveryBoyId: response.data.deliveryBoyId } }); // Redirect after login
        

      
      }
    } catch (error) {
      if (error.response) {
        const errorMessage = error.response.data?.message;
  
        if (errorMessage === "Login not allowed. Rider is already logged in") {
          alert("Login not allowed. Rider is already logged in");
        } else if (errorMessage === "Invalid credentials. password") {
          alert("Invalid credentials. Please check your password.");
        } else {
          alert(errorMessage || "An error occurred. Please try again.");
        }
      } else {
        console.error("Error logging in:", error);
        alert("Network error. Please try again later.");
      }
    
    }
  };
  

  const handleOutletChange = (e) => {
    const selectedOutletId = parseInt(e.target.value);
    setOutletId(selectedOutletId);
    localStorage.setItem("outletId", selectedOutletId);
  };

  // const handleClose = () => {
  //   navigate("/QrDashbordNavbar"); // Close the login page
  //   getOutletData(outletId);
  //   setLoginVisible("Yes")
  // };

  

  const getOutletData = async (outletId) => {
    try {
      
      const outletResponse = await axios.get(`${API_BASE_URL}/Outlet/GetOutletsByOutletId`, { params: { outletId }});

      if (outletResponse.data) {
        const distanceData = outletResponse.data[0];
        saveToLocalStorage(distanceData); // Save data to local storage
    }
      
      
      console.log(outletResponse.data);
    } catch (error) {
      console.log("API Error", error);
    }
    
  }

  

  return (
    <div className="container-fluid">
      <div className="row d-flex justify-content-center">
        <div className="d-flex justify-content-around align-items-center">
          <div className="d-flex align-items-center">
            <img
              src={LoginPageImage}
              className="loginpageimage me-2"
              alt="Login"
            />
            {/* <h1 className="mb-0">Login</h1> */}
          </div>

          <div>
            <img src={snoopy} className="snoopyimage" alt="" />
          </div>
        </div>

        <div>
          <div className="orange-line"></div>
        </div>
        <div className="col-md-6">
          <div className="backgroundcolor mt-3">
            <p className="SmallLoginText">Login</p>
            <div className="border p-3">
              <div className="Secondborder">
                <form className="text-center mt-5 mb-5" onSubmit={userLogin}>
                  <div className="mb-3 d-flex align-items-center">
                  
                    <input
                      type="text"
                      name="contactNo"
                      placeholder="Enter MobileNo"
                      className="form-control mobileNoOrPassword"
                      value={loginRequest.contactNo}
                      onChange={(e) =>
                        setLoginRequest({
                          ...loginRequest,
                          [e.target.name]: e.target.value,
                        })
                      }
                      required
                    />
                  </div>
                  <div className="mb-3 d-flex align-items-center position-relative">
                    
                    <input
                      type={showPassword ? "text" : "password"}
                      name="password"
                      placeholder="Enter Password"
                      className="form-control mobileNoOrPassword"
                      value={loginRequest.password}
                      onChange={(e) =>
                        setLoginRequest({
                          ...loginRequest,
                          [e.target.name]: e.target.value,
                        })
                      }
                      required
                    />
                    <span
                      className="position-absolute end-0 top-50 translate-middle-y me-5"
                      style={{ cursor: "pointer" }}
                      onClick={() => setShowPassword(!showPassword)}
                    >
                      <FontAwesomeIcon
                        className="faEyeSlashicon"
                        icon={showPassword ? faEye : faEyeSlash}
                      />
                    </span>
                  </div>

                  {outletId == 0 && (
                    <>
                    <div className="d-flex justify-content-center my-3">
                      <select
                        className="form-select"
                        value={outletId}
                        onChange={handleOutletChange}
                        style={{ width: "60%" }}
                      >
                        <option value={0} disabled>
                          Select an Outlet
                        </option>
                        {outletData.map((item) => (
                          <option key={item.outletId} value={item.outletId}>
                            {item.outletName}
                          </option>
                        ))}
                      </select>
                        
                    </div>
                    
                    </>
                  )}

                  {outletId > 0 && (
                    <p className="text-center mt-2">Selected Outlet: {outletId}</p>
                  )}

                  <div className="d-flex justify-content-between mt-4" style={{ width: "40%", marginLeft: "34%" }}>
                  {loginVisible === "Yes" && (
                    <button type="submit" className="btn btn LoginCanselButton border"
                  
                    >
                      Login
                    </button>)}
                    {/* {loginVisible === "No" && (
                    <button type="button" className="btn btn LoginCanselButton border" onClick={handleClose}>
                      Close
                    </button>)} */}
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserLogin;
